import { pathSubscription, regSub } from 'nike-re-framejs';

regSub('ui.sectionExpanded', (db, [_, section, defaultVal]) =>
    db.getIn(['gui', 'sectionExpanded', section], !!defaultVal)
);

regSub('ui.popup/ng', db => db.getIn(['gui', 'popup/ng', 0]));
export const popup$ = pathSubscription(['gui', 'popup/ng', 0]);

regSub('ui.headerTitle', db => db.getIn(['headerTitle']));

export const informationDutyLoaded$ = pathSubscription(['account', 'informationDutyLoaded']);
